import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

type ChargeAlertIcon = 'success' | 'error' | 'warning' | 'info' | 'question'

type BasicChargeAlertParams = {
  title: string
  text: string
  icon?: ChargeAlertIcon
  confirmButtonText?: string
}

type ChargeConfirmAlertParams = {
  title: string
  text: string
  icon?: ChargeAlertIcon
  confirmButtonText?: string
  cancelButtonText?: string
}

const chargeSwal = Swal.mixin({
  confirmButtonColor: '#1976d2',
  cancelButtonColor: '#9e9e9e',
  reverseButtons: true,
  heightAuto: false,
})

export const showChargeAlert = async ({
  title,
  text,
  icon = 'info',
  confirmButtonText = '확인',
}: BasicChargeAlertParams) => {
  return await chargeSwal.fire({
    title,
    text,
    icon,
    confirmButtonText,
  })
}

export const showChargeConfirmAlert = async ({
  title,
  text,
  icon = 'warning',
  confirmButtonText = '확인',
  cancelButtonText = '취소',
}: ChargeConfirmAlertParams) => {
  return await chargeSwal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  })
}
